var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_46897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9C18.5 9.414 18.164 9.75 17.75 9.75H1.25C0.836 9.75 0.5 9.414 0.5 9C0.5 8.586 0.836 8.25 1.25 8.25H17.75C18.164 8.25 18.5 8.586 18.5 9ZM5.75 16.5H4.25C3.0095 16.5 2 15.4905 2 14.25V12.75C2 12.336 1.664 12 1.25 12C0.836 12 0.5 12.336 0.5 12.75V14.25C0.5 16.3177 2.18225 18 4.25 18H5.75C6.164 18 6.5 17.664 6.5 17.25C6.5 16.836 6.164 16.5 5.75 16.5ZM17.75 12C17.336 12 17 12.336 17 12.75V14.25C17 15.4905 15.9905 16.5 14.75 16.5H13.25C12.836 16.5 12.5 16.836 12.5 17.25C12.5 17.664 12.836 18 13.25 18H14.75C16.8177 18 18.5 16.3177 18.5 14.25V12.75C18.5 12.336 18.164 12 17.75 12ZM14.75 0H13.25C12.836 0 12.5 0.336 12.5 0.75C12.5 1.164 12.836 1.5 13.25 1.5H14.75C15.9905 1.5 17 2.5095 17 3.75V5.25C17 5.664 17.336 6 17.75 6C18.164 6 18.5 5.664 18.5 5.25V3.75C18.5 1.68225 16.8177 0 14.75 0ZM1.25 6C1.664 6 2 5.664 2 5.25V3.75C2 2.5095 3.0095 1.5 4.25 1.5H5.75C6.164 1.5 6.5 1.164 6.5 0.75C6.5 0.336 6.164 0 5.75 0H4.25C2.18225 0 0.5 1.68225 0.5 3.75V5.25C0.5 5.664 0.836 6 1.25 6Z",
    fill: "#3C45FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_46897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.82000d3b00cb4ded7d6f0e3fc880016a.svg";
export { ForwardRef as ReactComponent };